<template>
  <div>
    <v-dialog v-model="show_dialog" width="500">
      <div class="neumorphism-pressed">
        <div
          class="topics-list-title-section d-flex justify-space-between align-center py-4 px-8"
        >
          <div class="topic-title">
            Topics List
          </div>
          <div>
            <button class="close-btn" @click="show_dialog = false">
              <v-icon class="close-icon">
                mdi-window-close
              </v-icon>
            </button>
          </div>
        </div>
        <div class="topics-list-table-wrapper">
          <div class="d-flex align-center justify-end mb-4">
            <button class="add-btn" @click="openAddTopic()">
              <div class="add-icon">
                Add
              </div>
            </button>
          </div>
          <v-data-table
            class="neumorphism-flat mt-2"
            :items="topics_list"
            :headers="topics_header"
            :loading="table_loading"
            hide-default-footer
          >
            <template v-slot:[`item.is_active`]="{ item }">
              <v-icon v-if="item.is_active" color="success">
                mdi-check-bold
              </v-icon>
              <v-icon v-else color="error">
                mdi-close-thick
              </v-icon>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <button class="close-btn" @click="openAddTopic(item)">
                <v-icon class="edit-icon">
                  mdi-text-box-edit-outline
                </v-icon>
              </button>
              <button
                class="close-btn ml-4"
                @click="openDeleteConfirmationDialog(item)"
              >
                <v-icon class="delete-icon">
                  mdi-delete-empty-outline
                </v-icon>
              </button>
            </template>
          </v-data-table>
        </div>
      </div>
    </v-dialog>
    <AddTopic ref="add_topic_dialog" @update="getNotificationTopicList" />
    <DeleteConfirmationDialog
      ref="delete_comfirmation_dialog"
      @update="getNotificationTopicList"
    />
  </div>
</template>
<script>
export default {
  components: {
    AddTopic: () => import("@/components/notifications/dialogs/AddTopic.vue"),
    DeleteConfirmationDialog: () =>
      import("@/components/notifications/dialogs/DeleteTopicTemplate.vue"),
  },
  data() {
    return {
      show_dialog: false,
      table_loading: false,
      topics_list: [],
      topics_header: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
          // class: "primary_2 white--text",
        },
        {
          text: "Topic Name",
          align: "start",
          sortable: false,
          value: "topic_name",
          // class: "primary_2 white--text",
        },
        {
          text: "Is Active",
          align: "start",
          sortable: false,
          value: "is_active",
          // class: "primary_2 white--text",
        },
        {
          text: "Actions",
          align: "start",
          sortable: false,
          value: "actions",
        },
      ],
    };
  },
  methods: {
    async openTopicListDialog() {
      this.show_dialog = true;
      await this.getNotificationTopicList();
    },
    getNotificationTopicList() {
      const self = this;
      self.table_loading = true;
      const lookup_key = "";
      self.topics_list = [];
      // self.tabs_item = [];
      let params = {};
      const successHandler = (response) => {
        // console.log("getNotificationTopicList", response);
        self.topics_list = response.data.result;
        self.table_loading = false;
      };
      const failureHandler = () => {
        self.table_loading = false;
      };
      const finallyHandler = () => {};
      self.GET_request(
        self,
        self.$urls.FCM_TOPIC,
        lookup_key,
        params,
        successHandler,
        null,
        failureHandler,
        finallyHandler
      );
    },
    openAddTopic(item) {
      this.$refs.add_topic_dialog.openAddTopicDialog(item);
    },
    openDeleteConfirmationDialog(value) {
      this.$refs.delete_comfirmation_dialog.openDeleteConfirmation(
        "topic",
        value
      );
    },
  },
};
</script>
<style scoped>
.topics-list-title-section {
  border-bottom: 1px solid #ffa70257 !important;
}
.topic-title {
  font-size: 20px;
  font-weight: 800;
  /* color: #6d7073; */
  color: #616467;
}
.close-btn {
  padding: 5px;
  border-radius: 50%;
  background: var(--kf-control) !important;
  border: 1px solid var(--kf-border) !important;
}
.close-icon {
  /* font-size: 72px; */
  font-weight: 900;
  background-color: #ffd641;
  background-image: linear-gradient(90deg, #ffd641 0%, #ff003c 100%);

  /* background-color: #ffe53b; */
  /* background-image: linear-gradient(147deg, #ffe53b 0%, #ff2525 74%); */

  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.close-btn:hover {
  background: var(--kf-hover);
}
.add-btn {
  padding: 7px 15px;
  border-radius: 20px;
  background: var(--kf-control) !important;
  border: 1px solid var(--kf-border) !important;
}
.add-icon {
  /* font-size: 72px; */
  font-weight: 900;
  background-color: hsla(197, 100%, 63%, 1);
  background-image: linear-gradient(
    90deg,
    hsla(197, 100%, 63%, 1) 0%,
    hsla(294, 100%, 55%, 1) 100%
  );

  /* background-color: #ffe53b; */
  /* background-image: linear-gradient(147deg, #ffe53b 0%, #ff2525 74%); */

  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.add-btn:hover {
  background: var(--kf-hover);
}
.edit-icon {
  /* font-size: 72px; */
  font-weight: 900;
  background-color: hsla(217, 100%, 50%, 1);
  background-image: linear-gradient(
    90deg,
    hsla(217, 100%, 50%, 1) 0%,
    hsla(186, 100%, 69%, 1) 100%
  );
  background-image: -moz-linear-gradient(
    90deg,
    hsla(217, 100%, 50%, 1) 0%,
    hsla(186, 100%, 69%, 1) 100%
  );
  background-image: -webkit-linear-gradient(
    90deg,
    hsla(217, 100%, 50%, 1) 0%,
    hsla(186, 100%, 69%, 1) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.delete-icon {
  /* font-size: 72px; */
  font-weight: 900;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  background-color: hsla(4, 84%, 49%, 1);

  background-image: linear-gradient(
    90deg,
    hsla(4, 84%, 49%, 1) 0%,
    hsla(37, 89%, 52%, 1) 100%
  );

  background-image: -moz-linear-gradient(
    90deg,
    hsla(4, 84%, 49%, 1) 0%,
    hsla(37, 89%, 52%, 1) 100%
  );

  background-image: -webkit-linear-gradient(
    90deg,
    hsla(4, 84%, 49%, 1) 0%,
    hsla(37, 89%, 52%, 1) 100%
  );
}
.edit-btn:hover {
  background: var(--kf-hover);
}
.topics-list-table-wrapper {
  padding: 15px 30px 40px 30px;
}
</style>
